/**
 * AIActivityIndicator — Pill "en vivo" con iconos giratorios mostrando qué
 * IA está trabajando en background (imágenes, recetas, alérgenos, ingredientes).
 * Extraído de DashboardLayout.jsx (iter.246 · Fase 8 UX Refactor).
 *
 * Consume `useImageGeneration()` directamente — auto-oculto si nada activo.
 */
import { Loader2, Sparkles } from "lucide-react";
import { useImageGeneration } from "../../context/ImageGenerationContext";

export function AIActivityIndicator() {
  const {
    imgGenActive, recipeGenActive, allergenGenActive, ingredientEnrichActive,
    imgTaskCount, recipeTaskCount, allergenTaskCount, ingredientEnrichCount,
  } = useImageGeneration();

  const anyActive =
    imgGenActive || recipeGenActive || allergenGenActive || ingredientEnrichActive;
  if (!anyActive) return null;

  const parts = [];
  if (imgGenActive) parts.push(`Imagenes (${imgTaskCount})`);
  if (recipeGenActive) parts.push(`Recetas (${recipeTaskCount})`);
  if (allergenGenActive) parts.push(`Alergenos (${allergenTaskCount})`);
  if (ingredientEnrichActive) parts.push(`Ingredientes (${ingredientEnrichCount})`);
  const label = parts.join(" + ");

  return (
    <div
      className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full bg-violet-100 dark:bg-violet-900/30 border border-violet-200 dark:border-violet-700"
      data-testid="ai-activity-indicator"
    >
      <Loader2 className="w-3.5 h-3.5 text-violet-600 dark:text-violet-400 animate-spin" />
      <span className="text-[11px] font-semibold text-violet-700 dark:text-violet-300 whitespace-nowrap">
        {label}
      </span>
      <Sparkles className="w-3 h-3 text-violet-500 dark:text-violet-400" />
    </div>
  );
}
